module.exports = __webpack_public_path__ + "media/luxury-2026/waterfront-kitchen-e6a32cbd.jpg";